import axiosInstance from "../config/axios";
import { privateList } from "../middlewares/transform/chat";
import AppStorage from "./AppStorage";

export default class ChatService {

  async createChat(payloadObject: any) {
    try {
      const createChat = await axiosInstance.post("session/create_chat", payloadObject)
      return createChat;
    }
    catch (error) {
      console.log(error)
    }
  }

  async getChatsUsingRoomId(room_id: any, session_map_id: any) {
    try {
      const response = await axiosInstance.post("session/read_chat", {
        room_id: room_id,
        session_map_id: session_map_id
      })
      return { data: response.data };
    } catch (error) {
      console.log(error)
    }
  }

  async getTraineeChats({session_map_id,traineeId }) {
    try {
      // const appStorage = new AppStorage();
      // const userData: any = appStorage.getItem("userData");
      const response1 = await axiosInstance.post("session/get_chat_user_trainee", {
        traineeId: traineeId,
        session_map_id: session_map_id
      });
      return response1.data;
    }
    catch (error) {
      console.log(error)
    }
  }

}
